<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              We may not always be able to face it on our own, let find the solution together
            </p>
          </div>
        </div>-->

        <div class="uk-padding  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h1 class=" uk-text-center specHeading">Counselling and Psychological Services Centre</h1>

            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                The Counselling and Psychological Services Centre (CPSC), operating in support of the mission and
                goals of the institution, strives to enhance the total development of the university students, workers and
                community patrons who request services, as well as those who are referred either by the University’s
                faculty and staff, the resident magistrate court, guidance counsellors, and medical doctors, among
                others. The counselling services are designed to address spiritual, academic, career, social and personal
                development of clients and the wider NCU family.

              </div>
              <div>
                <img src="../assets/psycho.jpg" class="uk-align-center" alt="">
              </div>

            </div>

          </div>
        </div>

        <div class="uk-padding uk-background-muted uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h3 class="uk-heading-divider specHeading">Goals of the department</h3>
            <div class="uk-child-width-1-2@m" uk-grid>
              <!--<hr class="uk-divider-icon">-->
              <div>
                <ul class="uk-list uk-list-divider">
                  The Counselling Centre staff will: <br>
                  <li>Enhance students’ self-awareness, interpersonal skills and personal development through
                    individual, couples and group counselling services and educational workshops.</li>
                  <li>Enhance student’s academic skills and learning strategies through academic counselling and
                    skills workshops.</li>
                  <li>
                    Support students’ career exploration; decision making and professional growth by providing
                    career assessment, counselling and workshops.
                  </li>
                  <li>
                    Emphasize programming needs and support to underserved populations in the NCU campus
                    community.
                  </li>
                  <li>Provide training to mental health professionals through individual and group supervision,
                    training seminars and consultation.</li>
                </ul>
              </div>
              <div>
                <ul class="uk-list uk-list-divider">
                  <br>
                  <li>
                    Provide crisis response and consultation to students, parents, faculty, student’s organizations
                    and administrators within the NCU community.
                  </li>
                  <li>
                    Advocate and support mental health on the NCU community through consultation,
                    presentations and psychological workshops.
                  </li>
                  <li>
                    Support the continued education and wellness of the Counselling Centre staff through on-going
                    personal and professional development initiatives.
                  </li>
                  <li>
                    Play an integral role in the campus-wide effort to prevent and treat mental health concerns
                    relevant to NCU, and provide assessment and referral when appropriate.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-padding">
          <div class="uk-container uk-container-small">


            <div class="uk-card  uk-grid-collapse uk-child-width-1-3@s uk-margin" uk-grid>
              <div class="">
                <h3>How to Make a Referral</h3>
              </div>
              <div>
                <div class="">
                  <a class="uk-button "  uk-tooltip="Click to view document " href="/requestDoc.pdf">Referral Document</a>
                </div>
              </div> <div>
              <div class="">
                <a class="uk-button "  uk-tooltip="Click to view document " href="/ref_form.pdf" target="_blank">Referral form</a>
              </div>
            </div>
            </div>


            <p>Here are a few ways in which you can make a referral to the Counselling & Psychological Services Centre (CPSC):</p>
            <ul class="top">
              <li>If a person’s life is at an <b>immediate threat</b> to self or others, call 911or 119 or visit the nearest police station, extension 7703 for Security on Campus</li>
              <li>If it is <b>not an immediate threat</b>, then call the Counselling & Psychological Services Centre (CPSC) at 876-963-7457 or extension 7457 from any telephone on campus.</li>
              <li>Talk with the student about the services the Counselling & Psychological Services Centre (CPSC) offers and how these might relate to his/her specific concern.</li>
              <li>Express your concern for the student’s welfare, and ask the student if he/she is talking to
                anyone about the concern discussed. If the student is not currently getting counselling, it
                is best that you express your concern and recommendation directly to the student as a
                <b>suggestion</b> and allow the student <b>to make his/her own decision</b>. You may also express
                that the Counselling & Psychological Services Centre (CPSC) staff has seen many
                students over the years with feelings and problems similar to his/her, and that we can help
                him/her work things out.</li>
              <li><b>Do not attempt to deceive or trick the student into seeking counselling.</b> Create a positive expectation.</li>
              <li>
                Make it clear that your recommendation for the student to seek counselling represents
                your best judgment based on your assessment of his/her particular problem(s). Be specific
                regarding the behaviours that have raised your concerns, and <b>avoid making
                generalizations about the individual.</b></li>
              <li>You can call and make an appointment for the student. This is usually best done while
                he/she is still with you and you can work out a mutually agreeable time for an
                appointment.</li>
              <li>
                You can come to the Counselling & Psychological Services Centre (CPSC) with the
                student, while he/she sets up the appointment. This tends to be the most successful type of
                referral, in which the student is most likely to follow up.
              </li>
              <li>
                Client confidentiality prohibits the Counselling & Psychological Services Centre (CPSC)
                staff from providing you with information about a student whom you have referred.
                However, it is appropriate for you to check back with the student to determine whether
                he/she has followed up on your recommendation. <b>Even if the student did not accept
                your attempted referral, it will show your continued interest and concern.</b>
              </li>

            </ul>
          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>

    export default {
        name: "cpc",
      components:{

      },
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Counselling and Psychology',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Department of Counselling and Psychology at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  a{background: #033860;
    color: #FFEB3B;
    border-radius: 3px}
  .top{
    margin-bottom: 100px;
  }

  @media screen and (max-width:600px){


    h3{
      font-size: 1.1em !important;
    }
    h1{
      font-size: 1.2em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }
    .uk-button{
  margin-top: 10px !important;
}

  }
</style>
